(() => {
  const root = document.querySelector('[data-strictly-skies]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const $ = s => root.querySelector(s);
  const status = $('[data-status]');
  const app = $('[data-app]');
  const alerts = $('[data-alerts]');
  const iconUrls = {
    clear: root.dataset.iconClear,
    partlyCloudy: root.dataset.iconPartlyCloudy,
    cloudy: root.dataset.iconCloudy,
    rain: root.dataset.iconRain,
    heavyWeather: root.dataset.iconHeavyWeather,
    snowIce: root.dataset.iconSnowIce,
    fogWind: root.dataset.iconFogWind
  };
  const key = 'strictly-skies-nws-v1';
  const home = { name: 'Cincinnati, OH', latitude: 39.1031, longitude: -84.512 };
  let current = home, generation = 0;
  let radarStation = 'KILN', radarZone = 'America/New_York';
  const safe = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const number = (n, suffix = '') => typeof n === 'number' && Number.isFinite(n) ? `${Math.round(n)}${suffix}` : 'Unavailable';
  const value = x => x?.value;
  const read = () => { try { return JSON.parse(localStorage.getItem(key)); } catch { return null; } };
  const write = data => { try { localStorage.setItem(key, JSON.stringify(data)); } catch {} };
  const say = message => { status.hidden = !message; status.textContent = message; };
  function updateRadar(station = radarStation, zone = radarZone) {
    radarStation = String(station || 'KILN').toUpperCase();
    radarZone = zone || 'America/New_York';
    const refresh = Math.floor(Date.now() / (5 * 60000));
    root.querySelectorAll('[data-radar-image]').forEach(image => {
      image.src = `https://radar.weather.gov/ridge/standard/${encodeURIComponent(radarStation)}_loop.gif?v=${refresh}`;
      image.alt = `Local observed weather radar loop from ${radarStation}`;
    });
    root.querySelectorAll('[data-radar-link]').forEach(link => {
      link.href = `https://radar.weather.gov/station/${encodeURIComponent(radarStation)}/standard`;
    });
    root.querySelectorAll('[data-radar-time]').forEach(time => {
      const now = new Date();
      time.dateTime = now.toISOString();
      time.textContent = `Checked ${now.toLocaleString('en-US', { timeZone: radarZone, weekday: 'short', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })}`;
    });
  }
  async function json(url) {
    const response = await fetch(url, { signal: AbortSignal.timeout(15000), headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Service returned ${response.status}`);
    return response.json();
  }
  const clock = (date, zone) => new Date(date).toLocaleString('en-US', { timeZone: zone, weekday: 'short', hour: 'numeric', minute: '2-digit' });
  function iconFor(forecast = '', precipitation = 0) {
    const text = forecast.toLowerCase();
    const heavyWeather = /thunder|lightning|tornado|hurricane|severe|heavy rain|downpour/.test(text);
    if (heavyWeather && Number(precipitation) > 60) return iconUrls.heavyWeather;
    if (/snow|sleet|ice|icy|freezing|flurr/.test(text)) return iconUrls.snowIce;
    if (/fog|haze|smoke|wind|breezy/.test(text)) return iconUrls.fogWind;
    if (/rain|shower|drizzle/.test(text)) return iconUrls.rain;
    if (/partly|mostly sunny|mostly clear|sun.*cloud|cloud.*sun/.test(text)) return iconUrls.partlyCloudy;
    if (/cloud|overcast/.test(text)) return iconUrls.cloudy;
    return iconUrls.clear;
  }
  const icon = (forecast, precipitation) => `<img src="${safe(iconFor(forecast, precipitation))}" width="72" height="72" alt="${safe(forecast)}" loading="lazy">`;
  function render(data) {
    const periods = data.hourly.properties.periods.filter(p => new Date(p.endTime) > Date.now());
    const p = periods[0] || data.hourly.properties.periods[0];
    if (!p) throw new Error('No forecast periods');
    updateRadar(data.point?.radarStation, data.zone);
    $('[data-place]').textContent = data.place.name;
    $('[data-updated]').textContent = `Forecast issued ${clock(data.hourly.properties.updateTime || data.hourly.properties.generatedAt, data.zone)}`;
    $('[data-temp]').textContent = number(p.temperature, '\u00b0F');
    $('[data-condition]').textContent = p.shortForecast;
    const currentIcon = $('[data-current-icon]');
    currentIcon.src = iconFor(p.shortForecast, value(p.probabilityOfPrecipitation));
    currentIcon.alt = p.shortForecast;
    currentIcon.hidden = false;
    $('[data-feels]').textContent = 'Current-hour forecast';
    $('[data-wind]').textContent = `${p.windDirection} ${p.windSpeed}`;
    $('[data-rain]').textContent = number(value(p.probabilityOfPrecipitation), '% chance');
    $('[data-humidity]').textContent = number(value(p.relativeHumidity), '%');
    ['gusts', 'visibility', 'pressure'].forEach(name => { $(`[data-${name}]`).textContent = 'Unavailable'; });
    $('[data-brief]').textContent = data.daily.properties.periods[0]?.detailedForecast || p.shortForecast;
    $('[data-hourly]').innerHTML = periods.slice(0, 24).map(h => `<article class="ssk-weather__hour"><strong>${safe(clock(h.startTime, data.zone))}</strong>${icon(h.shortForecast, value(h.probabilityOfPrecipitation))}<span>${number(h.temperature, '\u00b0F')}</span><small>${safe(h.shortForecast)}</small><small>${number(value(h.probabilityOfPrecipitation), '% precip.')}</small><small>${safe(h.windDirection)} ${safe(h.windSpeed)}</small></article>`).join('');
    $('[data-daily]').innerHTML = data.daily.properties.periods.filter(p => new Date(p.endTime) > Date.now()).map(d => `<article class="ssk-weather__report">${icon(d.shortForecast, value(d.probabilityOfPrecipitation))}<div><div><strong>${safe(d.name)}</strong><span>${number(d.temperature, '\u00b0F')} &middot; ${safe(d.windDirection)} ${safe(d.windSpeed)}</span></div><p>${safe(d.detailedForecast)}</p></div></article>`).join('');
    app.hidden = false;
  }
  async function observations(point, id) {
    try {
      const stations = await json(point.observationStations);
      const station = stations.features?.[0]?.id;
      if (!station) return;
      const obs = (await json(`${station}/observations/latest`)).properties;
      if (id !== generation || Date.now() - new Date(obs.timestamp) > 2 * 3600000) return;
      const gust = value(obs.windGust);
      $('[data-gusts]').textContent = gust == null ? 'Not reported' : number(gust / 1.609344, ' mph');
      $('[data-visibility]').textContent = value(obs.visibility) == null ? 'Not reported' : number(value(obs.visibility) / 1609.344, ' mi');
      $('[data-pressure]').textContent = value(obs.barometricPressure) == null ? 'Not reported' : number(value(obs.barometricPressure) / 100, ' hPa');
      $('[data-gusts]').closest('dl').title = `Gusts, visibility and pressure observed ${clock(obs.timestamp, point.timeZone)}`;
    } catch {}
  }
  async function loadAlerts(place, id) {
    alerts.hidden = false;
    alerts.textContent = 'Checking weather alerts...';
    try {
      const data = await json(`https://api.weather.gov/alerts/active?point=${place.latitude},${place.longitude}`);
      if (id !== generation) return;
      alerts.innerHTML = data.features.length ? data.features.map(({ properties: p }) => `<details><summary>${safe(p.event)}</summary><p>${safe(p.headline)}</p><p>${safe(p.description)}</p><p>${safe(p.instruction)}</p></details>`).join('') : 'No active NWS alerts for this location.';
    } catch { if (id === generation) alerts.textContent = 'Weather alerts could not be checked. Check weather.gov for current advisories.'; }
  }
  async function load(place, force = false) {
    const id = ++generation;
    current = place;
    say(`Loading ${place.name}...`);
    app.hidden = true;
    const cache = read();
    const same = cache?.place.latitude === place.latitude && cache?.place.longitude === place.longitude;
    if (same) { try { render(cache); say('Saved forecast; checking for updates...'); } catch {} }
    loadAlerts(place, id);
    try {
      if (!force && same && Date.now() - cache.saved < 15 * 60000) { say(''); observations(cache.point, id); return; }
      const point = (await json(`https://api.weather.gov/points/${Number(place.latitude).toFixed(4)},${Number(place.longitude).toFixed(4)}`)).properties;
      if (!point.forecastHourly || !point.forecast) throw new Error('Unsupported location');
      const [hourly, daily] = await Promise.all([json(point.forecastHourly), json(point.forecast)]);
      if (id !== generation) return;
      const data = { place, point, zone: point.timeZone, hourly, daily, saved: Date.now() };
      render(data); write(data); say(''); observations(point, id);
    } catch {
      if (id !== generation) return;
      say(same && !app.hidden ? 'Offline forecast shown. Forecast times may be out of date.' : 'Forecast unavailable for this location. Try again or select another U.S. location.');
    }
  }
  async function search() {
    const input = $('input[type="search"]').value.trim();
    if (!input) return;
    const id = ++generation;
    say('Finding your location...');
    const city = input.match(/^(.+),\s*([a-z]{2})$/i);
    if (!/^\d{5}$/.test(input) && !city) { say('Enter a five-digit U.S. ZIP code or a city and state abbreviation, such as Cincinnati, OH.'); return; }
    try {
      const path = city ? `${city[2].toLowerCase()}/${encodeURIComponent(city[1].trim())}` : input;
      const data = await json(`https://api.zippopotam.us/us/${path}`);
      if (id !== generation) return;
      const p = data.places?.[0];
      if (!p) throw new Error('No location');
      load({ name: `${city ? data['place name'] || city[1] : p['place name']}, ${data['state abbreviation'] || p['state abbreviation'] || city?.[2]}`, latitude: Number(p.latitude), longitude: Number(p.longitude) });
    } catch { if (id === generation) say('Location not found. Try a nearby U.S. ZIP code.'); }
  }
  $('[data-search]').addEventListener('click', search);
  $('input[type="search"]').addEventListener('keydown', e => { if (e.key === 'Enter') search(); });
  $('[data-locate]').addEventListener('click', () => {
    if (!navigator.geolocation) { say('Location access is unavailable. Search by ZIP code.'); return; }
    say('Getting your location...');
    navigator.geolocation.getCurrentPosition(p => load({name: 'Your location', latitude: Number(p.coords.latitude.toFixed(4)), longitude: Number(p.coords.longitude.toFixed(4))}), () => say('Location access unavailable. Search by ZIP code.'), {timeout: 10000, maximumAge: 300000});
  });
  root.querySelectorAll('[data-tab]').forEach(button => button.addEventListener('click', () => {
    root.querySelectorAll('[data-tab]').forEach(t => t.setAttribute('aria-selected', String(t === button)));
    root.querySelectorAll('[data-panel]').forEach(p => { p.hidden = p.dataset.panel !== button.dataset.tab; });
  }));
  $('[data-open-radar]').addEventListener('click', () => {
    const radarTab = root.querySelector('[data-tab="radar"]');
    radarTab.click();
    radarTab.focus();
    radarTab.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  $('[data-open-forecast]').addEventListener('click', () => {
    const hourlyTab = root.querySelector('[data-tab="hourly"]');
    hourlyTab.click();
    hourlyTab.focus();
    hourlyTab.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  const cached = read();
  load(cached?.place || home);
  setInterval(() => { if (!document.hidden) updateRadar(); }, 5 * 60000);
  setInterval(() => { if (!document.hidden) load(current, true); }, 15 * 60000);
})();
